import * as classnames from 'classnames/bind'
import * as React from 'react'
import { RouteComponentProps } from 'react-router'
import { Link } from 'react-router-dom'
import BasicLayout from '../../layouts/BasicLayout'
import styles from './error-page.scss'


const cx = classnames.bind({ ...styles })

interface IProps extends RouteComponentProps<any> { }

class ErrorPage extends React.Component<IProps> {

  public render() {
    return (
      <div style={{ zIndex: 10 }}>
        <BasicLayout>
          <div className={cx('wrapper', 'expert-page')}>
            {/* <!-- Start main --> */}
            <section className={cx('main')}>

              <main className={cx('g-height-100x', 'g-min-height-100vh', 'g-flex-centered', 'g-pa-15')}>
                <div className={cx('text-center', 'g-flex-centered-item', 'g-position-rel')}>
                  <div className={cx('g-absolute-centered', 'g-font-size-80', 'g-font-size-120--sm', 'g-font-size-420--lg', 'g-line-height-1', 'g-font-weight-200', 'g-color-gray-dark-v2', 'g-opacity-0_1')}>404</div>

                  <div className={cx('g-absolute-centered')}>
                    <p className={cx('g-color-black-opacity-0_6', 'g-font-size-24')}>Oops! 發生錯誤</p>
                    <p className={cx('g-color-black-opacity-0_6', 'g-font-size-18', 'g-mb-20')}>可以先試試 <a onClick={this.props.history.goBack} className={cx('g-color-black', 'g-color-primary--hover', 'g-text-no-underline--hover')}>回到上一頁</a></p>
                    <p className={cx('g-color-black-opacity-0_6', 'g-font-size-18')}>如果你的問題還是無法解決，<br />請至電 <a href="tel:0908533903" className={cx('g-color-black', 'g-color-primary--hover', 'g-text-no-underline--hover')}>0908533903</a> 客服專線</p>
                    <p className={cx('g-color-black-opacity-0_6', 'g-font-size-18', 'mb-0')}>或是<Link to="/" className={cx('g-color-black', 'g-color-primary--hover', 'g-text-no-underline--hover')}>回到首頁</Link></p>
                  </div>
                </div>
              </main>

            </section>
            {/* <!-- End main --> */}
          </div>
        </BasicLayout>
      </div>
    )
  }
}

export default ErrorPage


// WEBPACK FOOTER //
// ./src/pages/ErrorPage/index.tsx